module.exports = __webpack_public_path__ + "static/media/home-endorsement.a2f41d8d.png";